class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.triggerType = this.getAttribute('data-trigger') || 'click';
    this.hoverTimeout = null;
    this.isHovering = false;

    // Initialize hover functionality if enabled
    if (this.triggerType === 'hover') {
      this.initHoverBehavior();
    }
  }

  initHoverBehavior() {
    // Add hover event listeners
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

    // Prevent default click behavior on summary for hover mode
    const summary = this.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', (e) => {
        if (this.triggerType === 'hover') {
          e.preventDefault();
        }
      });
    }

    // Handle touch devices - fallback to click
    this.addEventListener(
      'touchstart',
      () => {
        if (this.triggerType === 'hover') {
          this.triggerType = 'click';
          this.removeEventListener('mouseenter', this.onMouseEnter.bind(this));
          this.removeEventListener('mouseleave', this.onMouseLeave.bind(this));
        }
      },
      { once: true }
    );
  }

  onMouseEnter() {
    if (this.triggerType !== 'hover') return;

    this.isHovering = true;

    // Clear any existing timeout
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }

    // Delay opening to prevent flickering
    this.hoverTimeout = setTimeout(() => {
      if (this.isHovering) {
        this.mainDetailsToggle.setAttribute('open', '');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
        this.onToggle();
      }
    }, 200); // 200ms delay for better UX
  }

  onMouseLeave() {
    if (this.triggerType !== 'hover') return;

    this.isHovering = false;

    // Clear any existing timeout
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }

    // Close immediately on mouse leave (no delay)
    this.hoverTimeout = setTimeout(() => {
      if (!this.isHovering) {
        this.close();
      }
    }, 100); // Short delay to prevent flickering when moving between elements
  }

  close() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
